module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "calibre_3",
    attrs: {
      "id": "filepos17704"
    }
  }, [_c('span', {
    staticClass: "calibre7"
  }, [_c('a', {
    staticClass: "calibre8"
  }), _c('span', {
    staticClass: "italic1"
  }, [_vm._v("Why Lazarus Laughed")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_4"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Essential Doctrine,"), _c('br', {
    staticClass: "calibre1"
  }), _vm._v("Zen - Advaita - Tantra")])])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_5"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "image",
      "src": "images/00002.jpg"
    }
  })])]), _c('div', {
    staticClass: "calibre_1"
  }), _vm._v(" "), _c('p', {
    staticClass: "calibre_2"
  }, [_c('span', {
    staticClass: "calibre9"
  }, [_vm._v("WEI WU WEI")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('img', {
    staticClass: "calibre3",
    attrs: {
      "alt": "image",
      "src": "images/00003.jpg"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre_5"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("SENTIENT PUBLICATIONS, LLC")])])]), _vm._v(" "), _c('div', {
    staticClass: "mbp_pagebreak",
    attrs: {
      "id": "calibre_pb_4"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f632f26a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_003.vue
// module id = 69
// module chunks = 0